export default "__VITE_ASSET__DHPBYOle__"